var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inscan-overage-shipment"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.hublist,
      "label": "text",
      "track-by": "value",
      "multiple": true,
      "searchable": true,
      "placeholder": "Select Hub",
      "hide-selected": true,
      "name": "searchHubId",
      "max": 10
    },
    model: {
      value: (_vm.hubIds),
      callback: function($$v) {
        _vm.hubIds = $$v
      },
      expression: "hubIds"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubIdError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.todate ? new Date(_vm.todate).setDate(new Date(_vm.todate).getDate() - 14) : '',
      "not-after": (_vm.todate) ? _vm.todate : _vm.todaysDate,
      "name": "FromDate"
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.FromDate,
      "not-after": (_vm.FromDate && (new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 14)) < _vm.todaysDate) ? new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 14) : _vm.todaysDate,
      "name": "todate"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.showOverageDetails()
      }
    }
  }, [_vm._v("Show")]), _vm._v("  \n                        "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearID
    }
  }, [_vm._v("Clear")]), _vm._v("  \n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID",
      "name": "ShippingID",
      "id": "ShippingID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIDError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-37px"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.showOverageDetails(_vm.shippingID)
      }
    }
  }, [_vm._v("Search")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.clearID
    }
  }, [_vm._v("Clear")])])], 1)])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ("" + ((_vm.updatedOverageShipmentList.length>0) ? 'showdest' : '')),
    staticStyle: {
      "overflow-x": "auto",
      "margin-top": "1%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader",
    attrs: {
      "colspan": "10"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "70%",
      "font-weight": "600"
    }
  }, [_vm._v("Total count:" + _vm._s(this.totalRows))]), _vm._v("   \n                                "), (_vm.updatedOverageShipmentList.length > 0) ? _c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportList
    }
  }, [_vm._v(" Export")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("User Email")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("Request Created Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Created Date And TimeStamp")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("Overage Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("View Image")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("Overage Marked Hub")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.updatedOverageShipmentList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.approvalrequestedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmenttype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.approvalrequesteddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.overagecount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-link', {
      on: {
        "click": function($event) {
          return _vm.downloadImage(data, 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b-link', {
      on: {
        "click": function($event) {
          return _vm.downloadImage(data, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-road'></i>"
      }
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.reasonlist,
        "track-by": "label",
        "label": "label",
        "multiple": false,
        "name": "Remark"
      },
      on: {
        "select": function (selected) { return _vm.selectedReason(selected, data.shippingid); }
      },
      model: {
        value: (_vm.reasonMap[data.shippingid]),
        callback: function($$v) {
          _vm.$set(_vm.reasonMap, data.shippingid, $$v)
        },
        expression: "reasonMap[data.shippingid]"
      }
    })], 1)], 1)], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "button-group"
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": _vm.disabledbuttonMapApproved[data.shippingid]
      },
      on: {
        "click": function($event) {
          return _vm.actionOnShipment(data, 'approved')
        }
      }
    }, [_vm._v("\n                                    Approve\n                                  ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "disabled": _vm.disabledbuttonMapRejected[data.shippingid]
      },
      on: {
        "click": function($event) {
          return _vm.actionOnShipment(data, 'rejected')
        }
      }
    }, [_vm._v("\n                                    Reject\n                                  ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))])])
  }), _vm._v(" "), (_vm.updatedOverageShipmentList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 20),
      expression: "totalRows>20"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "Image Preview",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeImage
    }
  }, [_vm._v("Close")])])]), _vm._v(" "), _c('img', {
    staticClass: "img-fluid mt-2",
    attrs: {
      "src": _vm.imgData,
      "alt": "Image Preview"
    }
  })])], 1)], 1)])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b79d372","hasScoped":true}!./src/views/components/OverageApprovalPanel/OverageApprovalPanel.html
// module id = 1991
// module chunks = 2